import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import { useProfile } from 'hooks'

import { PatientData } from '../CanceledScheduleDetailsModal.types'

import * as S from './styles'

export const PatientInfo: React.FC<PatientData> = (patientData) => {
  const { isPatient } = useProfile()

  return (
    <S.Container>
      <Typography variant="content2">Paciente: </Typography>
      <Typography weight='bold' variant="content2">{patientData.name}</Typography>
      {
        isPatient 
          ? null
          : <Typography variant="content2">{patientData.email}</Typography>
      }
    </S.Container>
  )
}